export type TabType = Configure | Preview;
export type Configure = 'Configure';
export type Preview = 'Preview';
export type ResourceId = string;

export enum CurrentPage {
    Dashboard = 'Dashboard',
    YatPageEdit = 'YatPageEdit',
    YatPageView = 'YatPageView',
    /**
     * 'IgnorePage' is to override the default 'Dashboard' fallback logic used in the initialReduxStore & initializeUser.
     */
    IgnorePage = 'IgnorePage',
}

export enum AssetTypes {
    Artifact = 'Artifact',
    Yat = 'Yat',
}
